/* eslint-disable no-else-return */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { List, ListItemText, Box, Alert, ListItemButton, Typography, CircularProgress, useTheme } from "@mui/material";
import { format, formatDistanceToNow } from "date-fns";
import { useLazyQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router";
import Scrollbar from "../custom-scroll/Scrollbar";
import { createFetch } from "../../gql/queries/ticket";
import useQuery from "../../hooks/allQuery";

function ChatListing() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const [ticketsFetch, setTicketsFetch] = useState([]);
  const [activeTickets, setActiveTickets] = useState("");
  const [loading, setLoading] = useState(true);
  const { userData } = useSelector(state => state.reducer);
  const [CREATE_FETCH] = useLazyQuery(createFetch, { fetchPolicy: "cache-and-network" });
  const { allQuery } = useQuery();
  useEffect(() => {
    if (userData?.id) {
      setLoading(true);
      allQuery({
        QUERY: CREATE_FETCH,
        variables: { userId: userData.id },
        onCompleteFunc: ({ ticketgetAll }) => {
          setTicketsFetch(ticketgetAll);
          setLoading(false);
          setActiveTickets(id || "");
        },
      });
    }
  }, [userData]);

  const handleClick = chatid => {
    setActiveTickets(chatid);
    navigate(`/support/chat/${chatid}`);
  };

  const formatDate = dateString => {
    const createdAt = new Date(dateString);
    const now = new Date();
    const diffInDays = Math.floor((now.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24));

    if (diffInDays === 1) return "Yesterday";
    if (diffInDays > 1) return format(createdAt, "dd MMM yyyy");
    return formatDistanceToNow(createdAt, { addSuffix: true });
  };

  return (
    <Box>
      <List sx={{ px: 0 }}>
        <Box px={2.5} py={1}>
          <Typography component="p" color="inherit" fontSize={16}>
            Recent chat
          </Typography>
        </Box>
        <Scrollbar
          sx={{
            height: { lg: "calc(100vh - 100px)", md: "100vh" },
            maxHeight: "600px",
          }}
        >
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
              <CircularProgress size={40} />
            </Box>
          ) : ticketsFetch?.length ? (
            ticketsFetch.map(chat => (
              <ListItemButton
                key={chat.ticketId}
                onClick={() => handleClick(chat?.ticketId)}
                sx={{
                  py: 1.5,
                  px: 3,
                  alignItems: "center",
                  backgroundColor: chat?.ticketId === activeTickets ? theme.palette.primary.main : "transparent",
                  "& h6": { color: chat?.ticketId === activeTickets ? "#ffffff" : theme.palette.text.primary },
                  "& p": { color: chat?.ticketId === activeTickets ? "#ffffff" : theme.palette.text.primary },
                  "&:hover": { backgroundColor: theme.palette.primary.main, "& h6, p": { color: "#ffffff" } },
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        fontSize: "12px",
                      }}
                      variant="subtitle2"
                      fontWeight={600}
                    >
                      {chat?.ticketId}
                    </Typography>
                  }
                  secondaryTypographyProps={{ noWrap: true }}
                  sx={{ my: 0 }}
                />
                <Box sx={{ flexShrink: "0" }}>
                  <Typography variant="body2">{formatDate(new Date(chat?.createdAt))}</Typography>
                </Box>
              </ListItemButton>
            ))
          ) : (
            <Box m={2}>
              <Alert severity="error" variant="filled" sx={{ color: "white" }}>
                No Tickets Found!
              </Alert>
            </Box>
          )}
        </Scrollbar>
      </List>
    </Box>
  );
}

export default ChatListing;
